import      React,
       {    useState, 
            useEffect, 
            useRef                      }   from "react";
import {    useNavigate                 }   from "react-router-dom";
import {    InputGeneral, 
            InputPassword     
                                        }   from "components/Field/field";
import      Style                           from "components/UI/main.module.scss";
import {    changePassword,
            changeSelfData
                                        }   from "./userConfigService";
import  {   GetSystemLabel,
            GetBusinessLabel,
            q3k_Reigan,
            q3z_IFunNumbers,
            qU3R0_FunData,
            GetAppLang,
            Spinner,
            getFeaturesPreferences,
            AppFeature,
        }                                   from "Utilities/utils";                                        
import { useModal }                         from "components/Covers/genericModal";
import { useToastMessage}                   from "components/Covers/toastMessage";
import {    SearchableDropdownList,}        from "components/DropdownListField/dropdownListFIeld";                                     

const blank_user_obj    = {
    Password:       "",
    PasswordConfirmation: "",
    Preferences:    {
        Language:       "",
        Features:       [],
    }
};

const LanguageContainer    = ({...setProps}) => {
    const {     User,
                SetUser
                                                    }       = setProps;    
    const langList = [
        {value: "Pt", label: GetSystemLabel("Portuguese")},
        {value: "En", label: GetSystemLabel("English")   },
        {value: "Es", label: GetSystemLabel("Spanish") },
    ];
    return (
        <React.Fragment>
            <SearchableDropdownList    
                value={User?.Preferences?.Language}
                placeholder={GetSystemLabel("Languages")}                                
                listOfItems={
                    langList && Array.isArray(langList)
                    ? 
                        langList.map((d) => ({ value: d.value, label: d.label }))
                    : 
                        null
                }
                style={{ width: "100%" }}  
                className={Style.antd_custom_select}                               
                popupClassName={Style.antd_custom_select}                              
                onChange={(event) => {            
                    SetUser(prev => ({
                        ...prev,
                        Preferences: {
                            ...prev.Preferences,
                            Language: event,
                        }
                    }));
                }}
            />            
        </React.Fragment>
    );
}; 
const PasswordContainer    = ({...setProps}) => {
    const {     User, 
                SetUser,
                SetIsLoading,         
                                }       = setProps;
    const [     isValid,
                setIsValid 
                                ]        = useState(false);
    const [     showControls,
                setShowControls
                                ]        = useState(false);
    const navigate                       = useNavigate();                                
    const { showToastMessage    }        = useToastMessage(); 

    function validateRecord() {
        if (    User.Password        != ""  && 
                User.Password.length >  8   &&
                User.Password.length <  35  &&
                User.PasswordConfirmation != ""  &&
                User.PasswordConfirmation.length > 8   &&
                User.PasswordConfirmation.length < 35  &&                                    
                q3k_Reigan(User.Password)   &&  
                q3k_Reigan(User.PasswordConfirmation)     ) {
                    return true;
        }
        else {
            return false;

        }
    }
    async function changePass() {
        if (validateRecord()) {
            SetIsLoading(true);
            let fetchedData = await changePassword(User);
            if (fetchedData) {
                if (fetchedData?.Status?.Code == 0) {
                    localStorage.removeItem("Charlore");
                    localStorage.removeItem("Tolkien");
                    navigate("/");
                    
                }
                else {
                    showToastMessage({header: GetSystemLabel("Warning"), message: fetchedData?.Status?.Message});
                }
            }
            SetIsLoading(false);            
        }
    }

    useEffect(() => {
        if (User.Password && User.PasswordConfirmation) {
            setIsValid(User.Password === User.PasswordConfirmation);
        } else {
            setIsValid(true);
        }
    }, [User]);

    return (
        showControls ? 
        (
            <React.Fragment>
                <div className={Style.row}>
                    <div className={[Style.col, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                        <div className={[Style.warning_bg, Style.rounded_2, Style.border_1, Style.shadow_sm].join(" ")}>
                            <div className={[Style.text_start, Style.ms_3].join(" ")}>
                                <span className={[Style.fs_8, Style.text_black, Style.fw_semibold].join(" ")}>
                                    {GetSystemLabel("PasswordRequirements")}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={Style.py_3}/>
                <div className={Style.row}>
                    <div className={[Style.col_sm].join(" ")}>
                        <span className={[Style.fs_8, Style.text_body, Style.mx_2].join(" ")}>{GetSystemLabel("PasswordNew")}</span>
                    </div>                        
                    <div className={[Style.col_sm].join(" ")}>
                        <InputPassword 
                            value={User?.Password}
                            type={"password"}
                            className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                            onChange={(event) => {
                                SetUser(prev => {
                                    return({
                                        ...prev,
                                        Password : qU3R0_FunData(event.target.value),
                                    });
                                });
                            }}                            
                            placeholder={GetSystemLabel("Password")}
                            maxLength={35}
                            icon_style={Style.btnEyePassword}
                            icon_style_hover={Style.btnEyePasswordHover}
                        />
                        <span className={[Style.ms_2, Style.text_body_faded, Style.fs_8].join(" ")}>{User?.Password?.length} {GetSystemLabel("of")} 35 {GetSystemLabel("Characters")}.</span>
                    </div>
                    <div className={[Style.col_sm].join(" ")}>
                        <span className={[Style.fs_8, Style.text_body, Style.mx_2].join(" ")}>{GetSystemLabel("PasswordConfirmation")}</span>
                    </div>
                    <div className={[Style.col_sm].join(" ")}>
                        <InputPassword 
                            value={User?.PasswordConfirmation}
                            type={"password"}
                            className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                            onChange={(event) => {
                                SetUser(prev => {
                                    return({
                                        ...prev,
                                        PasswordConfirmation: qU3R0_FunData(event.target.value),
                                    });
                                });
                            }}  
                            placeholder={GetSystemLabel("PasswordConfirmation")}
                            maxLength={35}
                            icon_style={Style.btnEyePassword}
                            icon_style_hover={Style.btnEyePasswordHover}
                        />
                        <span className={[Style.ms_2, Style.text_body_faded, Style.fs_8].join(" ")}>{User?.PasswordConfirmation?.length} {GetSystemLabel("of")} 35 {GetSystemLabel("Characters")}.</span>
                    </div>
                </div>
                <div className={Style.row}>
                    <div className={Style.col}>
                        {!isValid && (            
                            <p className={[Style.fs_8, Style.text_danger, Style.fw_semibold].join(" ")}>
                                {GetSystemLabel("WarningPasswordDoesNotMatch")}
                            </p>
                        )}
                    </div>
                </div>
                <div className={Style.row}>
                    <div className={[Style.col, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.clickable,
                                            Style.vanilla_bg, 
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.fs_8,
                                            Style.py_3,
                                            Style.px_5,
                                            Style.pop_item_animation,
                                            Style.text_center].join(" ")}
                                onClick={() => {
                                    changePass();
                                }}
                        >
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {GetSystemLabel("Save")}
                            </span>
                        </div>
                    </div>                    
                    <div className={[Style.col, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.clickable,
                                            Style.vanilla_bg, 
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.fs_8,
                                            Style.py_3,
                                            Style.px_5,
                                            Style.pop_item_animation,
                                            Style.text_center].join(" ")}
                                onClick={() => {
                                    setShowControls(prev => !prev);
                                }}
                        >
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {GetSystemLabel("Cancel")}
                            </span>
                        </div>
                    </div>
                </div>                
            </React.Fragment>
        )
        :
        (
            <React.Fragment>
                <div className={Style.row}>
                    <div className={[Style.col, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.clickable,
                                            Style.vanilla_bg, 
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.fs_8,
                                            Style.py_3,
                                            Style.px_5,
                                            Style.pop_item_animation,
                                            Style.text_center].join(" ")}
                                onClick={() => {setShowControls(prev => !prev);}}
                        >
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {GetSystemLabel("PasswordChange")}
                            </span>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
            
    );
};
const FeatureConfiguration = ({...setProps}) => {
    const {     FeatureList,
                UserFeature, 
                SetUserFeature      }       = setProps;
    const [featureLabel, setFeatureLabel]   = useState(null);

    useEffect(() => {
        if (FeatureList && UserFeature) {
            const Current = FeatureList?.find(f => f.FeatureId === UserFeature?.FeatureId);
            setFeatureLabel(Current);
        }

    }, [FeatureList, UserFeature, SetUserFeature]);

    return(
        <div className={[Style.card_bg, Style.shadow_sm, Style.rounded].join(" ")}>
            <div className={[Style.p_2].join(" ")}>
                <div className={Style.row}>
                    <div className={[Style.col, Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                        <div    style={{width: '1.0rem', height: 'auto'}} className={[Style.icon, Style.clickable, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}
                                onClick={() => {
                                    SetUserFeature.remove({ref: UserFeature});
                                }} 
                        >
                            <svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
                                <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                            </svg>
                        </div>
                        <div  className={[Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                            <span className={[Style.fs_8, Style.text_body, Style.mx_3].join(" ")}>{featureLabel?.desc}</span>
                        </div>
                    </div>
                    <div className={[Style.col_sm_1].join(" ")}>
                        <span className={[Style.fs_8, Style.text_body].join(" ")}>{GetSystemLabel("Row")}</span>
                        <InputGeneral 
                            value={UserFeature?.X}
                            className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                            onChange={(event) => {
                                SetUserFeature.update({ref: UserFeature, key:"X", value: q3z_IFunNumbers(event.target.value)});
                            }}
                            placeholder={GetSystemLabel("Size")}
                            maxLength={2}
                        />
                    </div>
                    <div className={[Style.col_sm_1].join(" ")}>
                        <span className={[Style.fs_8, Style.text_body].join(" ")}>{GetSystemLabel("Column")}</span>
                        <InputGeneral 
                            value={UserFeature?.Y}
                            className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                            onChange={(event) => {
                                SetUserFeature.update({ref: UserFeature, key: "Y", value: q3z_IFunNumbers(event.target.value)});
                            }}
                            placeholder={GetSystemLabel("Size")}
                            maxLength={2}
                        />
                    </div>
                    <div className={[Style.col_sm_1].join(" ")}>
                        <span className={[Style.fs_8, Style.text_body].join(" ")}>{GetSystemLabel("Width")}</span>
                        <InputGeneral 
                            value={UserFeature?.W}
                            className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                            onChange={(event) => {
                                SetUserFeature.update({ref: UserFeature, key: "W", value: q3z_IFunNumbers(event.target.value)});
                            }}
                            placeholder={GetSystemLabel("Size")}
                            maxLength={3}
                        />
                    </div>
                    <div className={[Style.col_sm_1].join(" ")}>
                        <span className={[Style.fs_8, Style.text_body].join(" ")}>{GetSystemLabel("Height")}</span>
                        <InputGeneral 
                            value={UserFeature?.H}
                            className={[Style.fs_8, Style.text_input, Style.border_1].join(" ")} 
                            onChange={(event) => {
                                SetUserFeature.update({ref: UserFeature, key: "H", value: q3z_IFunNumbers(event.target.value)});
                            }}
                            placeholder={GetSystemLabel("Size")}
                            maxLength={3}
                        />
                    </div>                                                                      
                </div>             
            </div>
        </div>            
    );
};
const PreferencesContainer = ({...setProps}) => {
    const [ mount,   setMount                       ]       = useState(false);          
    const [ featureList, setFeatureList             ]       = useState([]);            
    const {                    
                User,
                SetUser,
                SetIsLoading,
                DefaultFeature,
                UpdateLore,
                                                    }       = setProps;
    const { showToastMessage    }                           = useToastMessage(); 

    useEffect(() => {
        if (!mount) {
            DefaultFeature?.map((f) => (
                setFeatureList(prev => {
                    return([...prev, AppFeature(f)]);
                })
            ));
        }
    }, [DefaultFeature]);

    const handleSave                = async () => {
        SetIsLoading(true);
        let fetchedData = await changeSelfData(User);
        if (fetchedData) {
            if (fetchedData?.Status?.Code == 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                UpdateLore();
            }
            else {
                showToastMessage({header: GetSystemLabel("Warning"), message: fetchedData?.Status?.Message});
            }
        }
        SetIsLoading(false);
    };
    const handleFeatureSelection    = (feature) => {
        const exists = User?.Preferences?.Features?.some(f => f.FeatureId === feature);

        if (exists) return;

        SetUser(prev => ({
            ...prev,
            Preferences: {
                ...prev.Preferences,
                Features: [
                    ...prev.Preferences.Features,
                    {
                        FeatureId: feature,
                        X: 0,
                        Y: 0,
                        W: 0,
                        H: 0,
                        O: 0
                    }
                ]
            }
        }));
    };
    const handleFeatureUpdate       = (config) => {
        const value =  
            config.key === "W" ? 
                (isNaN(Number(config.value)) ? 0 : Number(config.value) > 100 ? 100 :  Number(config.value))
            :
            config.key === "Y" ? 
                (isNaN(Number(config.value)) ? 0 : Number(config.value) > 12 ? 12 :  Number(config.value))
            :
                isNaN(Number(config.value))  ? 0 : Number(config.value)
            ;
        SetUser(prev => ({
            ...prev,
            Preferences: {
                ...prev.Preferences,
                Features: prev.Preferences.Features.map(feature =>
                    feature.FeatureId === config.ref.FeatureId
                    ?   {
                            ...feature,
                            [config.key]: value
                        }
                    : 
                        feature
                )
            }
        }));
    };
    const handleFeatureDelete       = (config) => {
        SetUser(prev => ({
            ...prev,
            Preferences: {
                ...prev.Preferences,
                Features: prev.Preferences.Features.filter(
                    item => item.FeatureId !== config.ref.FeatureId
                )
            }
        }));
    };

    return(
        <React.Fragment>
            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                {GetSystemLabel("UserConfigWarningLanguageLabel")}
            </span>
            <div className={Style.py_2}/>
            <LanguageContainer
                User={User}
                SetUser={SetUser}
            />
            <div className={Style.py_2}/>
            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                {GetSystemLabel("UserConfigHomePageLabel")}
            </span>                   
            <div className={Style.py_2}/>
            <SearchableDropdownList    
                placeholder={GetSystemLabel("Features")}                                
                listOfItems={
                    featureList && Array.isArray(featureList)
                    ? 
                        featureList.map((d) => ({ value: d.FeatureId, label: d.desc }))
                    : 
                        null
                }
                style={{ width: "100%" }}  
                className={Style.antd_custom_select}                               
                popupClassName={Style.antd_custom_select}                              
                onChange={(event) => {            
                    handleFeatureSelection(event);
                }}
            />
            <div className={Style.py_2}/>            
            {User?.Preferences?.Features?.map((f) => <FeatureConfiguration FeatureList={featureList} UserFeature={f} SetUserFeature={{update: handleFeatureUpdate, remove: handleFeatureDelete}}/>)}
            <div className={Style.row}>
                <div className={[Style.col, Style.d_flex, Style.align_items_center, Style.justify_content_end].join(" ")}>
                    <div    className={[Style.d_flex, 
                                        Style.align_items_center, 
                                        Style.justify_content_center,
                                        Style.clickable,
                                        Style.vanilla_bg, 
                                        Style.rounded_3, 
                                        Style.border, 
                                        Style.shadow_sm, 
                                        Style.fs_8,
                                        Style.py_3,
                                        Style.px_5,
                                        Style.pop_item_animation,
                                        Style.text_center,
                                        Style.my_3].join(" ")}
                            onClick={async () => {
                                await handleSave();
                            }}
                    >
                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                            {GetSystemLabel("Save")} {GetSystemLabel("preferences")}
                        </span>
                    </div>
                </div>
            </div>                     
        </React.Fragment>
    );
};
const Container           = ({...setProps}) => {
    const {                      
                User,
                SetUser,
                IsLoading,
                SetIsLoading,
                UpdateLore,
                                    }            = setProps;
    const [ defaultFeature, setDefaultFeature       ]       = useState(null);  
    const [ mount,   setMount                       ]       = useState(false);  

    useEffect(() => {
        if (!mount) {
            setDefaultFeature(getFeaturesPreferences());
            setMount(true);
        }            
    }, []);
    
    useEffect(() => {
    }, [User, SetUser]);

    return (
        <React.Fragment>
            {IsLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={[Style.card_bg, Style.shadow_sm, Style.rounded].join(" ")}>
                        <div className={Style.row}>
                            <div className={Style.col_lg}>
                                <div className={Style.p_3}>
                                    <PreferencesContainer
                                        SetIsLoading={SetIsLoading}
                                        DefaultFeature={defaultFeature}
                                        User={User}
                                        SetUser={SetUser}
                                        UpdateLore={UpdateLore}
                                    />
                                </div>
                            </div>                   
                            <div className={Style.col_auto}>
                                <div className={Style.p_3}>
                                    <PasswordContainer
                                        SetIsLoading={SetIsLoading}
                                        User={User}
                                        SetUser={SetUser}
                                    />
                                </div>
                            </div>       
                        </div>
                    </div>
                </React.Fragment>
            }
        </React.Fragment>
    );
};

export const UserConfigPage = () => {
    const [ mount,          setMount                ]       = useState(false);
    const [userObj,     setUserObj  ]                       = useState(blank_user_obj);   // User Object
    const [ isLoading,  setIsLoading                ]       = useState(false);
    
    const updateLore = () => {        
        let pref = JSON.parse(localStorage.getItem("Charlore"));
        if (pref) {
            pref.Preferences.Language = userObj?.Language ?? pref.Preferences.Language;
            pref.Preferences.Features = userObj?.Preferences?.Features ?? pref.Preferences.Features;
            localStorage.setItem("Charlore", JSON.stringify(pref));
        }
    };
    useEffect(() => {
        if(!mount) {
            let pref = JSON.parse(localStorage.getItem("Charlore"));
            if (pref) {
                setUserObj(prev => {
                    return({
                        ...prev,
                        Preferences: {...pref?.Preferences}
                        
                    })                
                });
            }
            else {
                setUserObj(blank_user_obj);
            }
            setMount(true);
        }            
    }, []);
    
    return (
        <div className={[Style.m_2, Style.pb_5].join(" ")}>
            <Container 
                IsLoading={isLoading}
                SetIsLoading={setIsLoading}
                User={userObj}
                SetUser={setUserObj}
                UpdateLore={updateLore}
            />
            <div className={Style.py_2}/>
        </div>
    );
};